export function getClientInfo() {
    const ua = navigator.userAgent;

    let os = "Unknown OS";
    if (/Windows/.test(ua)) os = "Windows";
    else if (/Mac OS X/.test(ua)) os = "macOS";
    else if (/Android/.test(ua)) os = "Android";
    else if (/iPhone|iPad|iPod/.test(ua)) os = "iOS";
    else if (/Linux/.test(ua)) os = "Linux";

    let browser = "Unknown Browser";
    if (/Edg\//.test(ua)) browser = "Microsoft Edge";
    else if (/OPR\//.test(ua)) browser = "Opera";
    else if (/Chrome\//.test(ua)) browser = "Chrome";
    else if (/Safari/.test(ua) && !/Chrome/.test(ua)) browser = "Safari";
    else if (/Firefox\//.test(ua)) browser = "Firefox";
    else if (/MSIE|Trident/.test(ua)) browser = "Internet Explorer";

    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
    const device = isMobile ? "Mobile" : "Desktop";

    return {
        os,
        browser,
        device
    };
}

